import { ApiResponse, HttpMethod } from '../types';
import { getErrorResponse } from '../utils/errors';

export class ApiClient {
  public static get errorCodes() {
    return {
      network: 1,
      jsonParse: 2,
      unauthorised: 401,
      badRequest: 400,
      notFound: 404,
      tooManyRequests: 429,
      serverError: 500,
    };
  }

  protected get requestHeaders(): Record<string, string> {
    return {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    };
  }

  protected get mode(): 'cors' | 'navigate' | 'no-cors' | 'same-origin' | undefined {
    return undefined;
  }

  protected async _fetch<T>({
    path,
    method = 'GET',
    body = undefined,
    headers,
    abortSignal,
  }: {
    path: string;
    method?: HttpMethod;
    body?: Record<string, any> | string;
    headers?: Record<string, string>;
    isRetry?: boolean;
    abortSignal?: AbortSignal;
  }): Promise<ApiResponse<T>> {
    const isStringBody = typeof body === 'string';
    try {
      const response = await fetch(path, {
        method,
        headers: headers ? { ...this.requestHeaders, ...headers } : this.requestHeaders,
        body: body ? (isStringBody ? body : JSON.stringify(body)) : null,
        mode: this.mode,
        signal: abortSignal,
      });

      if (response.ok) {
        const result = await response.json().catch(() => {
          return {};
        });

        return { data: result, statusCode: response.status };
      }

      const responseText = await response.text();

      return { error: { message: responseText }, statusCode: response.status };
    } catch (error) {
      return getErrorResponse(error);
    }
  }
}
